export interface DocSection {
  id: string;
  title: string;
  description: string;
  path: string;
  icon?: string;
  subsections?: DocSection[];
}

export const documentationSections: DocSection[] = [
  {
    id: 'getting-started',
    title: 'Getting Started',
    description: 'Learn how to use the Haptic Music Player',
    path: '/docs/getting-started',
    subsections: [
      {
        id: 'introduction',
        title: 'Introduction',
        description: 'Overview of the Haptic Music Player',
        path: '/docs/getting-started/introduction'
      },
      {
        id: 'installation',
        title: 'Installation',
        description: 'How to install and set up the player',
        path: '/docs/getting-started/installation'
      }
    ]
  },
  {
    id: 'features',
    title: 'Features',
    description: 'Explore the features of the Haptic Music Player',
    path: '/docs/features',
    subsections: [
      {
        id: 'keyboard-shortcuts',
        title: 'Keyboard Shortcuts',
        description: 'List of all keyboard shortcuts and their functions',
        path: '/docs/features/shortcuts'
      },
      {
        id: 'haptic-feedback',
        title: 'Haptic Feedback',
        description: 'Understanding haptic feedback features',
        path: '/docs/features/haptic-feedback'
      }
    ]
  },
  {
    id: 'troubleshooting',
    title: 'Troubleshooting',
    description: 'Common issues and their solutions',
    path: '/docs/troubleshooting'
  }
];
